<template>
    <div>
      <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading" >
        <div class="header">
          <div class="back" @click="$router.back()">返回</div>
          <div class="title">发布内容</div>
        </div>
        <div class="import-title">
          <span class="cost-title-list-txt">基础信息</span>
        </div>
        <div class="customer-information">
          <div class="import-new-wrap">
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>标题</div>
              <el-input size="small" class="w240" maxlength="50"  placeholder="最多可输入50个字" v-model="form.medicineDictTitle"></el-input>
            </div>
            <div class="col-itms second">
              <div class="title"><span>*</span>内容分类</div>
              <el-select size="small" class="ipt-sty w240" multiple  v-model="form.contentCategoryGuids" placeholder="请选择">
                <el-option v-for="item in tagList" :key="item.guid" :label="item.categoryName" :value="item.guid">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
          <!-- 封面图 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms" style="align-items: flex-start;">
                <div class="title"><span>*</span>封面图</div>
                <!-- <div class="img-close"
                  v-if="form.coverUrl.length != 0 && form.coverUrl[0].path">
                  <img class="file-img" :src="form.coverUrl && form.coverUrl[0].path"
                    alt="" srcset="" />
                  <img class="close" @click="delPic" src="@/assets/images/ic_close.png" alt="" />
                </div>
                <div v-else class="icon-add" @click="addPic"><i class="el-icon-plus"></i></div> -->
                <div >
                  
                  <div class="import-btn-tips">
                      <el-button size="mini" class="btn-upload" icon="el-icon-my-import" type="importNew"
                      @click="addPic"
                        >上传文件</el-button
                      >
                      <div class="import-step-tip">支持上传jpg、jpeg、png等图片格式，单个文件大小≤5M</div>
                  </div>
                  <div v-if="form.coverUrl && form.coverUrl.length">
                    <div class="file-operate" >
                      <div class="file-name">{{ form.coverUrl[0].fileName }}</div>
                      <div class="file-preview" @click="onPreview(form.coverUrl[0])">查看</div>
                      <div class="file-preview" @click="handleMainRemove(form.coverUrl[0])">删除</div>
                      <div class="file-preview" @click="onDownload(form.coverUrl[0])">下载</div>
                    </div>
                  </div>
                  
                  <!-- <el-upload
                    size="small"
                    class="upload-demo t-left"
                    action="#"
                    ref="createProject"
                    :on-preview="onPreview"
                    :file-list="coverPhotoAttach"
                    accept=".jpg,.png,.jpeg"
                    :auto-upload="true"
                    :http-request="changeMainFile"
                    :limit="1"
                    :on-exceed="handleExceed"
                  >
                    <div class="file-operate" slot="file" slot-scope="{ file }">
                      <div class="file-name">{{ file.filename }}</div>
                      <div class="file-preview" @click="onPreview(file)">查看</div>
                      <div v-if="!isDisabled" class="file-preview" @click="handleMainRemove(file)">删除</div>
                      <div class="file-preview" @click="onDownload(file)">下载</div>
                    </div>
                    <div class="import-btn-tips">
                      <el-button size="mini" class="btn-upload" icon="el-icon-my-import" type="importNew"
                        >上传文件</el-button
                      >
                      <div slot="tip" class="import-step-tip">支持上传jpg、jpeg、png等图片格式，单个文件大小≤5M</div>
                    </div>
                    
                  </el-upload> -->
                  
                </div>
                <!-- 查看模式 -->
                <!-- <template v-else>
                  <div v-if="form.coverUrl && form.coverUrl.length">
                    <div class="file-operate" style="color: #606266" v-for="item in form.coverUrl" :key="item.path">
                      <span class="file-name">{{ item.fileName }}</span>
                      <span class="file-preview" @click="onPreview(item)">查看</span>
                      <span v-if="!isDisabled" class="file-preview" @click="handleMainRemove(item)">删除</span>
                      <span class="file-preview" @click="onDownload(item)">下载</span>
                    </div>
                  </div>
                  <div v-else>{{ '-' }}</div>
                </template> -->
              </div>
            </div>
          </div>
          <!-- 内容摘要 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span>*</span>内容摘要</div>
                <el-input
                    class="w640"
                    type="textarea"
                    :rows="3"
                    maxlength="150"
                    show-word-limit
                    placeholder="请输入"
                    v-model="form.contentAbstract"
                  >
                  </el-input>
              </div>
            </div>
          </div>
          <!-- 外部文章链接 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title"><span>*</span>外部文章链接</div>
                <el-input
                    class="w640"
                    type="textarea"
                    :rows="3"
                    maxlength="150"
                    show-word-limit
                    placeholder="请输入"
                    v-model="form.externalArticleUrl"
                    
                  >
                  </el-input>
              </div>
            </div>
          </div>
          <!-- 发布日期 -->
          <div class="cols">
            
            <div class="col-itms">
              <div class="title"><span>*</span>发布日期</div>
              <el-date-picker
                v-model="form.publishDate"
                type="date"
                :picker-options="expireTimeOption"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>
          <!-- 上架状态 -->
          <div class="import-new-wrap">
            <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>上架状态</div>
              <el-radio-group class="w300 content-left" v-model="form.bizState">
                <el-radio label="1">上架</el-radio>
                <el-radio label="2">下架</el-radio>
              </el-radio-group>
            </div>
          </div>
          </div>
       
        <div class="operte-btns">
          <div class="btn cancel" @click="$router.back()">取消</div>
  
          <div  class="btn submit" @click="saveReq">发布</div>
          <div v-if="!guid" class="btn submit" @click="saveReq(1)">发布下一个</div>
        </div>
      </div>
    </div>
    <!-- start of dialog-恋链首页分类图选择 -->
    <el-dialog title="选择图片" class="icon-dialog-wrap" :visible.sync="iconVisible" width="50%">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="search-area-div">图标名称</div>
            <el-input size="mini" v-model="paramValue" placeholder="请输入" class="ipt-sty" />
          </el-col>
          
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="info" @click="getIconList()">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="icon-dialog">
        
        <div class="icon-left">
          
          <div class="item" :style="activeIcon == index ? 'background:#EDEDED;' : ''" @click="handleClickMenu(index)"
            v-for="(item, index) in iconList" :key="index">
            <el-tooltip :content="item.paramName" placement="right" effect="light">
              <span>
                {{ item.paramName }}
              </span>
            </el-tooltip>
          </div>
        </div>
        <div class="icon-right">
          <div class="pic" v-for="(item, index) in iconList[activeIcon] &&
          iconList[activeIcon].paramValue &&
          JSON.parse(iconList[activeIcon].paramValue)" :key="index">
            <div class="img-wrap" @click="chooseIcon(item.url,item.name)">
              <el-image class="img" :src="item.url" fit="contain" />
              <img :style="chooseURL == item.url ? 'display:block' : 'display:none;'" class="border-img"
                src="@/assets/images/ic_select.png" alt="" />
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="moreSureIcon">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-恋链首页分类图选择 -->
    </div>
  </template>
  
  <script>
  export default {
    components: {},
    data() {
      return {
        tagList:[],//内容分类
        iconVisible:false,
        iconList: [],
        activeIcon: 0,
        chooseURL: null,
        fileName:'',
        fullscreenLoading: false,
        paramValue:'',//图标名称
        guid: '',
        form: {
          guid:'',//系统唯一标识
          medicineDictTitle:'',//标题
          contentCategoryGuids:[],// 内容分类GUID，[‘guid1’,’guid2’]
          coverUrl:[],	//封面图路径，[{"fileName":"","path":""},{"fileName":"","path":""}]
          contentAbstract:'',// 内容摘要
          externalArticleUrl:'',// 外部文章链接
          publishDate:new Date(),//发布日期
          bizState:'1',// 上架状态(1 上架, 2 下架)
        },
        coverPhotoAttach: [],
        fileSize: serverConfig.FILE_SIZE,
        restaurants: [],
        expireTimeOption:{
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6
          }
        }//时间限制当天以前可选
      };
    },
    watch: {
      iconVisible(val){
        if(!val){
          this.paramValue=''
          this.getIconList()
        }
      }
    },
    
    created() {
      if(this.$route.query.guid){
        this.guid=this.$route.query.guid
        this.getDetail();
      }
      this.getContentCategory()
      
      this.getIconList()
    },
    methods: {
       // 首页分类图
       handleClickMenu(index) {
      this.activeIcon = index;
    },
    chooseIcon(url,name) {
      this.chooseURL = url;
      this.fileName=name
    },
    moreSureIcon() {
      if (!this.chooseURL) {
        this.$message.error('请选择任务图标');
        return;
      }
      this.form.coverUrl = [
        {
          fileName: this.fileName,
          path: this.chooseURL,
        },
      ];
      console.log('778',this.form.coverUrl);
      
      this.iconVisible = false;
      this.$forceUpdate();
    },
    delPic() {
      this.form.coverUrl =[];
      this.$forceUpdate();
    },
    addPic() {
      if (this.form.coverUrl.length!=0) {
        this.$message.error('任务图标只能选择一个');
        return;
      }
      this.iconVisible = true;
    },
      //获取图标数据
    getIconList() {
      let that = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        paramValue:that.paramValue
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      that.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.iconList = res.data.data.records;
          that.activeIcon = 0;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    emptySearch(){
      this.paramValue=''
      this.getIconList()
    },
      getDetail() {
        let that = this;
        console.log('this.$route',this.$route);
        that.api.get(`/${serverConfig.msProductService}/medicine-dict/detail/${that.guid}`).then((res) => {
          
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
            let form = res.data.data
            form.coverUrl = form.coverUrl ? [JSON.parse(form.coverUrl)] : [];
            
            // form.coverUrl &&
            //   form.coverUrl.forEach((item) => {
            //     this.coverPhotoAttach.push({
            //       fileName: item.fileName,
            //       path: item.path,
            //     });
            //   });
           
            console.log('this.coverPhotoAttach',form.coverUrl);
            
            this.form = form;
            
          } else {
            that.$message.error(res.data.msg);
          }
        });
      },
      
      
      //提交申请
      saveReq(type) {
        if (!this.checkForm()) {
          return;
        }
        let form = JSON.parse(JSON.stringify(this.form));
        // form.coverUrl=JSON.parse(form.coverUrl)
        // let coverPhotoAttach = []
        
        let reqUrl;
        let method=''
        let message=''
        // this.coverPhotoAttach.forEach((item) => {
        //   coverPhotoAttach.push({
        //     fileName : item.fileName,
        //     path : item.path
        //   })
        // });
        // form.coverUrl = this.coverPhotoAttach.length ? coverPhotoAttach : null;
        if (this.guid) {
          reqUrl = `/${serverConfig.msProductService}/medicine-dict/update`;
          form.guid = this.guid;
          method='put'
          message='修改成功'
        } else {
          reqUrl = `/${serverConfig.msProductService}/medicine-dict/add`;
          form.guid = null;
          method='postJson'
          message='新增成功'
        }
        this.fullscreenLoading = true;
        this.api[method](reqUrl, form).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: message,
              type: 'success',
            });
            if(type==1){
              // 添加下一个，数据清空
              this.form={
                guid:'',//系统唯一标识
                medicineDictTitle:'',//标题
                contentCategoryGuids:[],// 内容分类GUID，[‘guid1’,’guid2’]
                coverUrl:[],	//封面图路径，[{"fileName":"","path":""},{"fileName":"","path":""}]
                contentAbstract:'',// 内容摘要
                externalArticleUrl:'',// 外部文章链接
                publishDate:new Date(),//发布日期
                bizState:'1',// 上架状态(1 上架, 2 下架)
              }
              this.coverPhotoAttach= []
            }else{
              this.$router.go(-1);
            }
            
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      // 返回上一页
      
      // 获取内容分类
      getContentCategory(){
        let that=this
        let req = {
          pageIndex:1,
          pageSize:-1,
          categoryType:1
        };
        
        that.api.postJson(`/${serverConfig.msProductService}/content-category/list`, req).then((res) => {
          
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.tagList = res.data.data.records;
          } else {
            that.$message.error(res.data.msg);
          }
        });
      },
      onPreview(file) {
        var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
        if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
          return window.open(file.path, file.fileName);
        }
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
      },
      onDownload(file) {
        window.open(file.path + '?response-content-type=application/octet-stream');
      },
      
     
      handleMainRemove(file) {
        this.form.coverUrl.forEach((item, index) => {
          if (item.path == file.path) {
            this.form.coverUrl.splice(index, 1);
          }
        });
      },
      // 上传文件
      changeMainFile(file) {
        let isLt5M = file.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
        if (!isLt5M) {
          this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
          this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
          return;
        }
        let formData = new FormData();
        formData.append('file', file.file);
        formData.append('fileName', file.file.name);
        this.fullscreenLoading = true;
        this.api
          .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.coverPhotoAttach.push({
                fileName: file.file.name,
                path: res.data.data.data,
              });
              this.$message({
                message: '上传成功',
                type: 'success',
              });
            } else {
              this.$message.error('上传失败!');
            }
          })
          .catch(() => {
            this.$message('上传失败！');
          });
      },
      
     
      handleExceed(files, fileList) {
        this.fileList = [];
        this.$message.warning('当前限制选择1个文件');
      },
     
      
      checkForm() {
        if (!this.form.medicineDictTitle) {
          this.$message.error('标题不能为空');
          return false;
        }
        if (!this.form.contentCategoryGuids.length) {
          this.$message.error('内容分类不能为空');
          return false;
        }
        // if (!this.form.coverUrl) {
        //   this.$message.error('封面图不能为空');
        //   return false;
        // }
        if (!this.form.coverUrl.length) {
          this.$message.error('封面图不能为空');
          return false;
        }
        if (!this.form.contentAbstract) {
          this.$message.error('内容摘要不能为空');
          return false;
        }
        if (!this.form.externalArticleUrl) {
          this.$message.error('外部文章链接不能为空');
          return false;
        }
        if (!this.form.publishDate) {
          this.$message.error('发布日期不能为空');
          return false;
        }
        if (!this.form.bizState) {
          this.$message.error('上架状态不能为空');
          return false;
        }
        
        
        return true;
      },
     
     
    },
  };
  </script>
  
  <style lang="less" scoped>
  /deep/.el-input-number__decrease {
    display: none;
  }
  /deep/.el-input-number__increase {
    display: none;
  }
  /deep/ .el-input-number .el-input__inner {
    text-align: left;
    padding-left: 15px;
  }
  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }
  
  .flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
  }
  
  .pdt100 {
    padding-bottom: 100px !important;
  }
  
  .header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
  
  .header .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
  
  .import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
    position: relative;
  }
  
  .empty-tooltip {
    background: #fff;
    font-size: 16px;
    padding: 25px 0;
  }
  
  .import-title.second {
    margin-top: 4px;
  }
  
  .header .title {
    text-align: center;
    flex: 1;
  }
  
  .customer-information {
    background: #fff;
    padding-bottom: 15px;
  }
  
  .customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    line-height: 28px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  
  .sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
  }
  
  .sub-operate-add2 {
    color: #4fa1a4;
    font-size: 14px;
    margin-left: 14px;
    cursor: pointer;
    position: absolute;
    right: 35px;
    top: 10px;
    text-align: center;
  }
  
  .sub-operate-del {
    font-size: 14px;
    color: #4fa1a4;
    cursor: pointer;
    text-align: center;
    margin: 0 20px;
  }
  
  .customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
  }
  
  .customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  
  .customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
  }
  
  .customer-information .col-itms.second {
    margin-left: 170px;
  }
  
  .customer-information .col-itms .title span {
    color: red;
  }
  .w640{
    width:640px
  }
  .import-new-wrap {
    padding-bottom: 15px;
  }
  
  .import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 10px;
    color: #666;
    font-size: 12px;
  }
  
  .import-new-wrap .col-itms {
    align-items: baseline;
  }
  
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }
  
  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .operte-btns .btn.save {
    border: 1px solid #4FA1A4;
    color: #4FA1A4;
    cursor: pointer;
  }
  
  .operte-btns .btn.submit {
    border: 1px solid #4FA1A4;
    background: #4FA1A4;
    color: #fff;
    cursor: pointer;
  }
  .file-operate {
    display: flex;
    margin-top: 5px;
  }
  .file-preview {
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
  }
  .bank-content {
    text-align: left;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
  }
  .bank-info {
    color: #a7a7a7;
  }
  
  .content-left {
    text-align: left;
  }
  .btn-upload {
    width: 84px;
    height: 28px;
    padding: 0;
  }
  .icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 180px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
  
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 80px;
  height: 80px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 80px;
}

.img-close {
  position: relative;
  float: left;
  width: 80px;
  height: 80px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
  </style>
  <style>
  .cols-content{
      
      .el-textarea{
        width:840px
      }
    }
  .icon-dialog-wrap .el-dialog__body {
    padding: 0;
    padding-top: 10px;
  }
  #template-config .el-dialog {
      /* height: 80vh; */
      overflow: auto;
  }
  #template-config .el-form-item__content{
    margin-left:15px !important;
    display: flex;
  }
  #template-config .el-form-item{
    align-items:flex-start;
  }
  #template-config .calc-type .el-form-item__label{
    line-height:15px;
  }
  .el-table .cell{
    white-space: nowrap;
  }
    .el-input__inner{
      padding: 0 8px;
    }
    .detail-class .el-table__row{
      height: 12px;
      line-height: 12px;
    }
    .el-collapse-item__header {
      padding-left: 15px;
    }
    
    .el-upload--picture-card {
      float: left;
      margin-right: 10px;
    }
    
    .circle-closesty {
      position: relative;
      top: -35px;
      margin-left: 112px;
      font-size: 20px;
      cursor: pointer;
    }
    
    .v-modal {
      z-index: 100 !important;
    }
    
    .select-box {
      overflow: hidden;
      margin: 0 0px 10px 30px;
    }
    
    .box-left {
      width: 40%;
      height: 350px;
      padding: 0 20px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
      overflow-y: auto;
    }
    
    .box-right {
      width: 57%;
      height: 350px;
      padding: 0 10px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
    }
    
    .field-radio {
      display: flex;
      align-items: center;
    }
    
    .field-radio .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-form-item {
      margin-bottom: 18px;
    }
    
    .other-config {
      display: flex;
      font-size: 14px;
      padding-left: 50px;
      /* padding-top: 30px; */
    }
    
    .other-content {
      flex: 1;
    }
    
    .other-content-list {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    
    .other-title {
      padding-right: 10px;
    }
    
    /* 报货配置 */
    .bh-config-box {
      display: flex;
      height: 40px;
      align-items: center;
      font-size: 14px;
      padding-left: 50px;
      padding-top: 10px;
    }
    
    .bh-config-title {
      margin-right: 10px;
    }
    
    /* 库存信息采集 */
    .kc-label {
      font-size: 12px;
      color: #86909c;
    }
    
    .kc-label span {
      color: #4fa1a4;
      cursor: pointer;
    }
    
    .kc-box {
      padding: 16px;
      box-sizing: border-box;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
      color: #323232;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #323232;
    }
    .el-tabs__item.is-active{
      color: #4fa1a4;
    }
    .kc-box .el-tabs__item {
      border-right: 1px solid #dcdfe6 !important;
    }
    
    .kc-tab-box {
      height: 340px;
      padding: 0 0 40px;
      font-size: 14px;
      overflow-y: auto;
      box-sizing: border-box;
    }
    
    .kc-tab-list {
      padding: 0 0 40px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdcdc;
    }
    
    .kc-tab-list:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
    
    .kc-tab-label {
      display: flex;
      margin-top: 30px;
    }
    
    .label-left-name img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    
    .tab-label-left {
      width: 350px;
      display: flex;
      margin-right: 20px;
    }
    
    .label-left-name {
      width: 100px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      flex-shrink: 0;
    }
    
    .tab-label-right {
      display: flex;
      align-items: center;
      color: #c8c8c8;
    }
    
    .tab-label-add {
      color: #4fa1a4;
      cursor: pointer;
      margin-right: 10px;
    }
    
    .tab-label-del {
      color: #d0021b;
      cursor: pointer;
      margin: 0 10px;
    }
    
    .kc-tab-rules {
      display: flex;
      margin-top: 16px;
    }
    
    .kc-rules-center {
      display: flex;
      align-items: center;
    }
    
    .rules-center-input span {
      margin: 0 8px;
    }
    
    .kc-no-label {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .kc-no-label img {
      width: 213px;
      margin-right: 35px;
    }
    
    .no-label-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    
    .no-label-text h3 {
      font-size: 18px;
      color: #7f828f;
      text-align: left;
      font-weight: 500;
      margin: 0;
    }
    
    .no-label-text p {
      font-size: 14px;
      color: #7f828f;
      line-height: 20px;
      margin: 6px 0 13px;
      text-align: left;
    }
    
    .no-label-btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      text-align: center;
      color: #4fa1a4;
      cursor: pointer;
      border: 1px solid #4fa1a4;
    }
    
    .dy-table {
      width: 800px;
      margin-left: 10px;
    }
    
    .dy-table .dy-table-title {
      display: flex;
      height: 60px;
      line-height: 60px;
      background: #f2f2f2;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table .dy-table-title div {
      width: 200px;
    }
    
    .dy-table .dy-table-item {
      display: flex;
      height: 50px;
      align-items: center;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table-item-label {
      width: 200px;
      flex-shrink: 0;
      text-align: center;
    }
    
    .dy-table .dy-radio-box {
      width: 200px !important;
      text-align: center;
    }
    
    .dy-config-wrap {
      display: flex;
      font-size: 14px;
      margin: 30px 0;
      padding-left: 50px;
    }
    
    .dy-config-title {
      flex-shrink: 0;
      margin-top: 20px;
    }
    
    .product-select-all {
      margin-bottom: 20px;
    }
    .title-content {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      width: 100%;
    }
    .title-item {
      vertical-align: middle;
      text-align: center;
      padding-right: 10px;
    }
    .left-text {
      text-align: left;
    }
    .w200 {
      width: 30%;
    }
    .w160 {
      width: 160px;
    }
    .w240 {
      width: 200px;
    }
    .w100 {
      width: 100px;
    }
    .configure-fields {
      width: 760px !important;
    }
    .configure-fields .el-dialog__body {
      overflow-y: auto;
      max-height: 600px;
    }
    .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /* 选项内容样式 */
    .select-content-box {
      width: 92%;
      margin: 0 0px 10px 30px;
    }
    .select-content {
      width: 100%;
      /* padding:0 10px; */
      background: #fafafa;
      border: 1px solid #e5e5e5;
    }
    .el-form-item__label {
      color: #666;
    }
    .select-content .el-form-item__label {
      width: 90px !important;
    }
    .select-content .el-form-item__content {
      margin-left: 90px !important;
    }
    .config-item .el-form-item__content {
      margin-left: 0px !important;
    }
    /*  */
    .max-value {
      position: relative;
      height: 40px;
    }
    .max-value .el-input-number--mini {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 104px;
    }
  </style>
  
  